import { getCookie, isEmpty } from "src/utils/browserHelpers";
import {
  APP_AGENT,
  APP_AGENT_DEVICE,
  PERSONALIZATION,
  // REQUEST_METHODS,
} from "src/constants/network";
import { apiHelper } from "src/utils/apiHelpers";
import { DOMAIN } from "constants/common";

export interface IPersonalizationResponse {
  status: number;
  headers: Record<string, string>;
}

/**
 * This function is getting called at client side so did not add isServer check
 */
export const personalization = async (localStorageDeviceId?: string | null) => {
  let deviceId = {};
  if (localStorageDeviceId) {
    deviceId = {
      dvid: localStorageDeviceId,
    };
  }
  try {
    const headers = {
      caller: window?.location?.origin,
      [APP_AGENT]: APP_AGENT_DEVICE,
      ...deviceId,
    };

    return apiHelper(
      `${DOMAIN}${PERSONALIZATION}`,
      "GET",
      undefined,
      undefined,
      headers
    );
  } catch (e) {
    console.error(e);
  }
};

/**
 * This function is getting called at client side so did not add isServer check
 */
export const deviceId = async () => {
  const localStorageDeviceId = window?.localStorage?.getItem("dvid");
  const getDeviceIdCookie = getCookie("ct-dvId") || "";

  try {
    if (
      (isEmpty(localStorageDeviceId) && isEmpty(getDeviceIdCookie)) ||
      (isEmpty(localStorageDeviceId) && !isEmpty(getDeviceIdCookie))
    ) {
      const req = await personalization();
      const { status, headers } = (req || {}) as IPersonalizationResponse;
      if (status === 204) {
        window?.localStorage?.setItem("dvid", headers["dvid"]);
      }
    } else if (!isEmpty(localStorageDeviceId) && isEmpty(getDeviceIdCookie)) {
      await personalization(localStorageDeviceId);
    }
  } catch (e) {
    console.error(e);
  }
};
